import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ReplayAnalizerExportComponent } from "./replay-analizer-export.component";


@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [ReplayAnalizerExportComponent],
  declarations: [ReplayAnalizerExportComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ReplayAnalizerExportComponentModule {}
